var map = {
	"./yh0.png": "2OvW",
	"./yh1.png": "7It7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nrTP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index ^\.\/yh.*\.png$
// module id = nrTP
// module chunks = 3